export default __webpack_public_path__ + "static/career-success-application-thumb-up-db7e169f45ffd5459198afda3557a2b6.svg";